<template>
  <transition name="rightSlide" appear>
    <div class="accountModal" :style="styles">
      <div class="accountModal__header">
        <close-icon class="accountModal__header__close" color="#FFF" @click.native="$emit('close')"/>
        <span class="accountModal__header__title">アカウント</span>
      </div>
      <div class="accountModal__infoAreaWrap">
        <div class="accountModal__infoArea">
          <attention v-if="attentionText" :text="attentionText" @click.native="attentionClickEvent"/>
          <div class="accountModal__info">
            <account-icon width="21" height="21" :color="headColor" />
            <div class="accountModal__info__contents">
              <div class="accountModal__info__name">{{ userInfo.nickname }}</div>
              <div>{{ userInfo.email }}</div>
              <div>{{ userProf.birthday === '0000-00-00' ? null : userProf.birthday | birthFomat }}</div>
            </div>
            </div>
        </div>
        <div class="accountModal__menuList">
          <list-menu
            :menu-list="menuList"
            :font-color="fontColor"
            :icon-color="iconColor"
            :head-color="headColor"
            :hover-color="hoverColor"
            />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import * as type from '@/utvStore/store/mutation-types'
import { ACCOUNT_MENU } from './const'
import { convertKanjiYMD } from '@/utils/filters'
import moment from 'moment'
import ListMenu from './ListMenu'
import Attention from './Attention'
import AccountIcon from './icon/AccountIcon'
import CloseIcon from './icon/CloseIcon'

export default {
  name: 'accountModal',
  components:{
    ListMenu,
    Attention,
    AccountIcon,
    CloseIcon
  },
  props: {
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
  },
  data() {
    return {
      menuList: [],
      attentionText:'',
      attentionClickEvent:()=>{}
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.user,
      userProf: state => state.account.profile,
      subscInfo: state => state.account.subscription
    }),
    fontColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.fontColor){
        return this.colorScheme.fontColor
      }else{
        return '#434a54'
      }
    },
    iconColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.keyColor){
        return this.colorScheme.keyColor
      }else{
        return '#ff7497'
      }
    },
    headColor(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.keyColor){
        return this.colorScheme.keyColor
      }else{
        return '#ff7497'
      }
    },
    infoBg(){
      if(Object.keys(this.colorScheme).length > 0 && this.colorScheme.infoBg){
        return this.colorScheme.infoBg
      }else{
        return null
      }
    },
    hoverColor(){
      const defGrad = 'linear-gradient(59.75deg, #fff3f5 21.4%, #f9f4fd 76.64%)'
      if(Object.keys(this.colorScheme).length > 0){
        if(!!this.colorScheme.hoverColor){
          return this.colorScheme.hoverColor
        }else{
          if(!!this.colorScheme.gradStart && /#[0-9a-z]{6}/i.test(this.colorScheme.gradStart)
            && !!this.colorScheme.gradEnd && /#[0-9a-z]{6}/i.test(this.colorScheme.gradEnd)
          ){
            const stMtc = this.colorScheme.gradStart.match(/#([0-9a-z]{2})([0-9a-z]{2})([0-9a-z]{2})/i)
            const endMtc = this.colorScheme.gradEnd.match(/#([0-9a-z]{2})([0-9a-z]{2})([0-9a-z]{2})/i)
            if(!!stMtc && stMtc.length === 4 && !!endMtc && endMtc.length === 4){
              console.log(parseInt(stMtc[1], 16), parseInt(stMtc[2], 16), parseInt(stMtc[3], 16))
              const baseAlpha = 0.1
              return `linear-gradient(59.75deg, rgba(${parseInt(stMtc[1], 16)},${parseInt(stMtc[2], 16)},${parseInt(stMtc[3], 16)},${baseAlpha}) 21.4%, rgba(${parseInt(endMtc[1], 16)},${parseInt(endMtc[2], 16)},${parseInt(endMtc[3], 16)},${baseAlpha}) 76.64%)`
            }else{
              return defGrad
            }
          }else{
            return defGrad
          }
        }
      }else{
        return defGrad
      }
    },
    styles(){
      const initcol_keycolor = '#ff7497'
      const initcol_second = '#cb8bff'
      const base = !!this.headColor && this.headColor.length > 0 && /#[0-9a-z]{6}/i.test(this.headColor) ? this.headColor : initcol_keycolor
      const mtc = base.match(/#([0-9a-z]{2})([0-9a-z]{2})([0-9a-z]{2})/i)
      return {
        '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : initcol_keycolor,
        '--info-bg': !!this.infoBg ? this.infoBg : `rgba(${parseInt(mtc[1], 16)},${parseInt(mtc[2], 16)},${parseInt(mtc[3], 16)},0.08)`,
        '--base-bg': !!this.colorScheme && !!this.colorScheme.baseBg ? this.colorScheme.baseBg :
          `linear-gradient(86.51deg, ${!!this.colorScheme.gradStart ? this.colorScheme.gradStart : initcol_keycolor} 21.4%, ${!!this.colorScheme.gradEnd ? this.colorScheme.gradEnd : initcol_second} 76.64%)`
      }
    }
  },
  filters: {
    birthFomat(val) {
      return val ? `${val.substring(0,4)}年${val.substring(4,6)}月${val.substring(6,val.length)}日生まれ`: val
    }
  },
  watch:{
    subscInfo:{
      handler(n){
        this.selectedMenu()
      },
      deep: true
    }
  },
  created(){
    this.selectedMenu()
  },
  methods:{
    selectedMenu(){
      //メニュー出し分け
      this.menuList = this.subscInfo.active ? ACCOUNT_MENU.SUBSC : ACCOUNT_MENU.ID
      this.menuList[2].title = `保有ポイント ${Number(this.userInfo.user_point).toLocaleString()}pt`

      switch(parseInt(this.subscInfo.status)){
        // サブスク初回 or 継続中
        case 0:
        case 1:
          this.menuList[1].title = 'サブスクリプション継続中'
          this.menuList[1].children[1].title = 'サブスクリプションの解約'
          this.menuList[1].children[1].url = '/subsc/cancel'
          this.menuList[1].children[1].closeModal = true
          this.attentionText = ''
          break
        // サブスク停止中
        case 2:
          this.menuList[1].title = 'サブスクリプション停止中'
          this.menuList[1].children[1].title = 'サブスクリプションの申込'
          this.menuList[1].children[1].url = '/subsc/rejoin'
          this.menuList[1].children[1].closeModal = true
          this.attentionText = `${convertKanjiYMD(this.subscInfo.next_payment_due)}のお引き落としができなかったため、サブスクリプションが停止しています。 再開するには<a href="" style="color:#FF7497;pointer-events:none;">こちら</a>からお手続きをお願いします。 `
          this.attentionClickEvent = this.transitionRejoin
          break
        // サブスク解約申込
        case 3:
          this.menuList[1].title = 'サブスクリプション解約手続き済み'
          // サブスク解約手続きの取り消しを一旦トルツメするため。コメントアウト＆children.splice(1, 1)
          // this.menuList[1].children[1].title = 'サブスクリプション解約手続きの取り消し'
          // this.menuList[1].children[1].url = '/subsc/changed_mind'
          this.menuList[1].children.splice(1, 1)
          const time = parseInt(this.userInfo.subscription.current_peirod_to) * 1000
          const peirodTo = window.moment(time).format('YYYY年M月D日')
          this.attentionText = `サブスクリプションの解約手続き済みです。${peirodTo}までご利用になれます。`
          break
        // サブスク解約済み
        case 4:
          this.menuList[1].title = 'サブスクリプション未登録'
          this.menuList[1].children[1].title = 'サブスクリプションの申込'
          this.menuList[1].children[1].url = '/subsc/rejoin'
          this.menuList[1].children[1].closeModal = true
          break
        //未登録
        default:
          this.menuList[1].title = 'サブスクリプション未登録'
          this.menuList[1].children[1].title = 'サブスクリプションの申込'
          this.menuList[1].children[1].url = '/subsc/join'
          this.menuList[1].children[1].closeModal = true
          break
      }
    },
    transitionRejoin(){
      this.$store.dispatch(type.ACCOUNT_MODAL_VISIBILITY, false)
      location.href = '/subsc/rejoin'
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";

.accountModal{
  height: 100vh;
  width: 100%;
  position: fixed;
  background: white;
  top: 0;

  @include mq('pc') {
    max-width: 340px;
    right: 0;
    top: 44px;
    box-shadow: -10px 0px 20px rgba(0, 0, 0, 0.1);
  }

  &__header{
    height: 44px;
    background: var(--base-bg);
    padding: 0 20px;
    display: flex;
    align-items: center;
    pointer-events: auto;

    &__title{
      font-size: 16px;
      line-height: 44px;
      color: $col_white;
      margin-left: 9px;
    }

    @include mq('pc') {
      display: none;
    }
  }
  &__infoAreaWrap{
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    overflow-scrolling: touch;
    height: 100%;
    padding-bottom: 120px;
    pointer-events: auto;

  }

  &__infoArea{
    background: var(--info-bg);
    color: $col_base_black;
    padding: 17px 20px;
  }

  &__menuList{
    padding: 15px 20px 20px;
  }

  &__info{
    display: flex;

    &__contents{
      margin-left: 20px;
    }

    &__name{
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      color: var(--key-color);
    }
  }
}

.rightSlide-enter-active, .rightSlide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;
}

.rightSlide-enter, .rightSlide-leave-to {
  transform: translateX(100vw);
  @include mq('pc') {
    transform: translateX(340px) translateX(0px);
  }
}

ul {
  list-style: none;
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/common/AccountModal.vue